import { gql } from '@apollo/client';

export const QUOTE_AFTERMARKET_PRODUCT_FRAGMENT = gql`
  fragment QuoteAftermarketProductFields on QuoteAftermarketProductResponse {
    type
    cost
    description
    equipmentId
  }
`;
